<template>
  <transition name="el-message-fade" @after-leave="handleAfterLeave">
    <div
      :class="[
        'el-message',
        type && `el-message--${ type }`,
        center ? 'is-center' : '',
        showClose ? 'is-closable' : '',
        customClass
      ]"
      :style="positionStyle"
      v-show="visible"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
      role="alert">
      <svg-icon v-show="type==='error'" icon-class="el-icon-error" style="fill:#F56C6C;font-size: 15px;margin-right: 6px" ></svg-icon>
      <svg-icon v-show="type==='success'" icon-class="el-icon-success" style="fill:#E6A23C;font-size: 15px;margin-right: 6px" ></svg-icon>
      <slot>
        <div>
          <div >
            <span v-if="!dangerouslyUseHTMLString" class="el-message__content">{{ message }}</span>
            <span v-else v-html="message" class="el-message__content"></span>
          </div>
          <div v-if="!!content">
            <span style="font-size: 12px" class="el-message__content">{{ content }}</span>
          </div>
        </div>
      </slot>
      <i v-if="showClose" class="el-message__closeBtn el-icon-close" @click="close"></i>
    </div>
  </transition>
</template>

<script type="text/babel">
  const typeMap = {
    success: 'success',
    info: 'info',
    warning: 'warning',
    error: 'error',
    alarm: 'alarm',
  };

  export default {
    data() {
      return {
        visible: false,
        content:'',
        message: '',
        duration: 3000,
        type: 'info',
        customClass: '',
        onClose: null,
        showClose: false,
        closed: false,
        verticalOffset: 20,
        timer: null,
        dangerouslyUseHTMLString: false,
        center: false
      };
    },

    computed: {
      typeClass() {
        return `el-icon-${ typeMap[this.type] }`
      },
      positionStyle() {
        return {
          'top': `${ this.verticalOffset }px`
        };
      }
    },

    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
        }
      }
    },

    methods: {
      isElIcon(){
        return !this.type || ['success','error','warning','info'].includes(this.type)
      },
      handleAfterLeave() {
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },

      close() {
        this.closed = true;
        if (typeof this.onClose === 'function') {
          this.onClose(this);
        }
      },

      clearTimer() {
        clearTimeout(this.timer);
      },

      startTimer() {
        if (this.duration > 0) {
          this.timer = setTimeout(() => {
            if (!this.closed) {
              this.close();
            }
          }, this.duration);
        }
      },
      keydown(e) {
        if (e.keyCode === 27) { // esc关闭消息
          if (!this.closed) {
            this.close();
          }
        }
      }
    },
    mounted() {
      this.startTimer();
      document.addEventListener('keydown', this.keydown);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.keydown);
    }
  };
</script>
